"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SipTrunkTransportEnum = void 0;
exports.SipTrunkTransportEnum = {
    Auto: "auto",
    Udp: "udp",
    Tcp: "tcp",
    Tls: "tls",
};
